import { noop } from 'lodash';
import React from 'react';

import { css } from '@emotion/core';
import CloseButton from '@images/svgs/close-icon.svg';
import { Box } from '@rebass/emotion';
import Colors from '@theme/colors';

interface ModalProps {
  visible: boolean;
  width?: any;
  height?: any;
  backdrop?: boolean;
  style?: object;
  onClose?: (e: {}) => void;
  closeOnBackdrop?: boolean;
  children: any;
}

// TODO: Prevent body scroll when modal is open
const Modal = ({ visible, onClose, width, backdrop, closeOnBackdrop, children }: ModalProps) => {
  return visible ? (
    <Box data-i="send-email">
      <Box
        onClick={closeOnBackdrop ? onClose : noop}
        css={css`
          position: fixed;
          width: 100%;
          height: 100vh;
          top: 0;
          background: ${Colors.neutral75};
          opacity: ${backdrop ? 0.2 : 0};
          z-index: 1;
          overflow-y: hidden;
        `}
      />
      <Box
        width={[0.95, 0.6, 0.3]}
        css={css`
          height: 446px;
          border-radius: 4px;
          background-color: #ffffff;
          box-shadow: 0 -2px 31px 13px rgba(64, 87, 93, 0.06);
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          z-index: 9;
        `}
      >
        <CloseButton
          onClick={onClose}
          css={css`
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
          `}
        />
        {children}
      </Box>
    </Box>
  ) : null;
};

Modal.defaultProps = {
  width: [0.8, 0.6, 0.3],
  backdrop: true,
  onClose: noop,
  closeOnBackdrop: true,
};

export { Modal };
